// extracted by mini-css-extract-plugin
export default {"container":"AddFaq_container__yu4ks","heading":"AddFaq_heading__CrNlF","form":"AddFaq_form__LJtde","buttonContainer":"AddFaq_buttonContainer__-QLWs"};